import pdf from "@react-pdf/renderer";
import * as React from "react";

const { View, Text } = pdf;
interface Props {
  indexHierarchyList: any[];
  style;
}

interface State {}

export default class OrganisationIndexHierarchyPDF extends React.Component<
  Props,
  State
> {
  renderIndexHierarchy = (indexHierarchyList) => {
    return indexHierarchyList.map((item, index) => {
      let isLastElement =
        indexHierarchyList.indexOf(item) === indexHierarchyList.length - 1;
      return (
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            lineHeight: 3
          }}
        >
          {index === 0 ? (
            <Text style={this.props.style.hierarchyItem}>{`${item}`}</Text>
          ) : (
            <Text style={this.props.style.hierarchyGroups}>{item}</Text>
          )}
          {!isLastElement && (
            <Text style={this.props.style.arrowStyle}>{`<`}</Text>
          )}
        </View>
      );
    });
  };

  render() {
    let { indexHierarchyList } = this.props;

    return (
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "wrap"
        }}
      >
        {this.renderIndexHierarchy(indexHierarchyList)}
      </View>
    );
  }
}
